// src/unAuth/components/Footer.js
import React from "react";
import "./Footer.css";

export default function Footer() {
  return (
    <footer className="footer-container" data-animate="fade-up">
      <div className="footer-branding">
        <div className="footer-brand-description">
          <span className="footer-timestamp-highlight">Timestampgn</span> — Free
          AI-powered YouTube timestamp generator. Create shareable chapter
          markers for any video in seconds.
        </div>
        <p className="footer-transparency">
          We use YouTube&apos;s public API in compliance with Google&apos;s Terms of
          Service. We do not store, republish, or claim ownership of any video
          content—we only generate timestamp text for your own use. Your
          generated lists are kept locally in your browser.
        </p>
      </div>
      <div className="footer-bottom">
        <span>© {new Date().getFullYear()} Timestampgn. All rights reserved.</span>
        <a
          href="https://bumpups.com/terms-of-service"
          target="_blank"
          rel="noopener noreferrer"
          className="footer-contact-link"
        >
          Terms of Service
        </a>
        <a
          href="https://bumpups.com/privacy-policy"
          target="_blank"
          rel="noopener noreferrer"
          className="footer-contact-link"
        >
          Privacy Policy
        </a>
      </div>
    </footer>
  );
}
